import $ from 'jquery';
import 'slick-carousel';

const GET_TWEETS_URL = '/dd_twitter_feed/get_tweets';

const requestData = {
  cache: true,
  dataType: 'html',
};

const slickSettings = {
  speed: 200,
  dots: true,
  arrows: false,
  slidesToShow: 3,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        variableWidth: true,
      },
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        adaptiveHeight: true,
      },
    },
  ],
};

class TwitterFeed {
  constructor(element) {
    this.$element = $(element);
    this.success = this.success.bind(this);
    this.complete = this.complete.bind(this);
    this.request = this.sendRequest();
  }

  sendRequest() {
    return $.ajax(GET_TWEETS_URL, requestData)
      .success(this.success)
      .complete(this.complete)
    ;
  }

  success(data) {
    const $tweets = this.$element.find('.tweets');
    $tweets.html(data);
    $tweets.slick(slickSettings);
  }

  complete() {
    this.$element.addClass('ready');
  }
}

export default TwitterFeed;



// WEBPACK FOOTER //
// ./TwitterFeed.js